module.exports = __webpack_public_path__ + "static/media/match-ring.9f7b72ff.png";